import ImportDynamicTagsModal from './ImportDynamicTagsModal';

export default ImportDynamicTagsModal;
